export function normalizeLocationType(rawType, fallbackLocation = '') {
  const raw = (rawType ?? '').toString().trim();
  if (raw) {
    const numeric = Number(raw);
    if (Number.isFinite(numeric)) {
      if (numeric === 1) return 'FLOOR';
      if (numeric === 2) return 'RACK';
      if (numeric === 3 || numeric === 6) return 'PICKING';
    }
    const upper = raw.toUpperCase();
    if (upper.includes('FLOOR')) return 'FLOOR';
    if (upper.includes('RACK')) return 'RACK';
    if (upper.includes('PICK')) return 'PICKING';
  }
  const locUpper = (fallbackLocation ?? '').toString().trim().toUpperCase();
  if (locUpper.startsWith('FLOOR')) return 'FLOOR';
  if (locUpper.startsWith('RACK')) return 'RACK';
  if (locUpper.startsWith('PICK')) return 'PICKING';
  return '';
}

export function formatLocationLabel({
  location,
  locationTypeId,
  stackLabel,
  includeStack = true,
} = {}) {
  const loc = (location ?? '').toString().trim();
  const stack = (stackLabel ?? '').toString().trim();
  const type = normalizeLocationType(locationTypeId, loc);

  if (type === 'FLOOR' || loc.toUpperCase() === 'FLOOR') {
    if (includeStack && stack) return `FLOOR - ${stack}`;
    return 'FLOOR';
  }

  if (!loc) {
    return type || '';
  }

  if (type === 'RACK' || type === 'PICKING') {
    const remainder = loc.replace(/^(FLOOR|RACK|PICKING)\s+/i, '').trim();
    const suffix = remainder || loc;
    return suffix ? `${type} ${suffix}` : type;
  }

  return loc;
}
